module.exports = __webpack_public_path__ + "static/media/L (5).a87380be.jpg";